import React, { Component } from 'react'
import { Icon, Table, Input } from 'antd';
import { connect } from 'react-redux';
import moment from 'moment';

import { get_letter } from '../actions/print.action';

// Styles
import './../style.css';

class RecommendationLetter extends Component {

    constructor( props ){
        super( props );

        this.state = {
            data: [],
            to_position: "The Manager",
            to_address: "MASHREQ BANK",
            to_location: "Dubai",
            to_salary: 1000,
            to_account: 80008000800,
            to_hr: 'Sajina Salim',
            to_hr_position: 'Finance Manager',
            to_hr_email: 'sajina@digitalventure.com',
            to_hr_company: 'Digital Venture FZ LLC',
        }

    }

    componentWillMount(){
        this.props.get_letter( this.props.match.params.id );
    }

    componentWillReceiveProps( nextProps ){

        console.log( nextProps );
        
        if( nextProps.print.length != 0 ){
            this.setState({
                data: nextProps.print.OUTPUT.DATA[0]
            })

            setTimeout(() => {
                // window.print();
            },500)

        }

    }

    handleDate_formate( date ){
        return moment( date ).format('Do of MMMM YYYY');
    }

    handleHonorific( status, gender ){

        if( gender === 'male' ){
            if( status === 'married' || status === 'single' ){
                return 'Mr.';
            }
        }

        if( gender === 'female' ){
            if( status === 'married' ){
                return 'Mrs.';
            }
            if( status === 'single' ){
                return 'Miss.';
            }

        }

    }

    convertNumberToWords( amount ) {

        if( isNaN( amount ) === true ){
            return '';
        }

        let dec = amount.toString().split(".");

        var n = dec[0];

        var string = n.toString(), units, tens, scales, start, end, chunks, chunksLen, chunk, ints, i, word, words, and = 'and';

        /* Remove spaces and commas */
        string = string.replace(/[, ]/g,"");

        /* Is number zero? */
        if( parseInt( string ) === 0 ) {
            return 'Zero';
        }
        
        /* Array of units as words */
        units = [ '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen' ];
        
        /* Array of tens as words */
        tens = [ '', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety' ];
        
        /* Array of scales as words */
        scales = [ '', 'Thousand', 'Million', 'Billion', 'Trillion', 'Quadrillion', 'Quintillion', 'Sextillion', 'Septillion', 'Octillion', 'Nonillion', 'Decillion', 'Undecillion', 'Duodecillion', 'Tredecillion', 'Quatttuor-Decillion', 'Quindecillion', 'Sexdecillion', 'Septen-Decillion', 'Octodecillion', 'Novemdecillion', 'Vigintillion', 'Centillion' ];
        
        /* Split user argument into 3 digit chunks from right to left */
        start = string.length;
        chunks = [];
        while( start > 0 ) {
            end = start;
            chunks.push( string.slice( ( start = Math.max( 0, start - 3 ) ), end ) );
        }
        
        /* Check if function has enough scale words to be able to stringify the user argument */
        chunksLen = chunks.length;
        if( chunksLen > scales.length ) {
            return '';
        }
        
        /* Stringify each integer in each chunk */
        words = [];
        for( i = 0; i < chunksLen; i++ ) {
            
            chunk = parseInt( chunks[i] );
            
            if( chunk ) {
                
                /* Split chunk into array of individual integers */
                ints = chunks[i].split( '' ).reverse().map( parseFloat );
            
                /* If tens integer is 1, i.e. 10, then add 10 to units integer */
                if( ints[1] === 1 ) {
                    ints[0] += 10;
                }
                
                /* Add scale word if chunk is not zero and array item exists */
                if( ( word = scales[i] ) ) {
                    words.push( word );
                }
                
                /* Add unit word if array item exists */
                if( ( word = units[ ints[0] ] ) ) {
                    words.push( word );
                }
                
                /* Add tens word if array item exists */
                if( ( word = tens[ ints[1] ] ) ) {
                    words.push( word );
                }
                
                /* Add 'and' string after units or tens integer if: */
                if( ints[0] || ints[1] ) {
                    
                    /* Chunk has a hundreds integer or chunk is the first of multiple chunks */
                    if( ints[2] || ! i && chunksLen ) {
                        words.push( and );
                    }
                
                }
                
                /* Add hundreds word if array item exists */
                if( ( word = units[ ints[2] ] ) ) {
                    words.push( word + ' Hundred' );
                }
                
            }
            
        }
        
        var words_string =  words.reverse().join( ' ' );

        if( dec[1] ){
            return words_string + ' and ' + dec[1] + ' / 100 ';
        } else {
            return words_string;
        }
        
    }

    render() {
        return (
            <div className="print_wrapper letter">
                
                <table width="100%">

                    <thead>
                        <tr>
                            <th colSpan="2">
                                <span className="print_logo"></span>
                                <span className="jgroup_logo"></span>
                            </th>
                        </tr>
                    </thead>

                    <tbody>

                        <tr>
                            <td valign="top">

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ height: '60px' }}>&nbsp;</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td style={{textAlign: 'right'}}>Date: { this.handleDate_formate( this.state.data.request_date ) }</td>
                                        </tr>
                                    </tbody>
                                </table>


                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ height: '30px' }}>&nbsp;</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%">
                                                <h2 style={{ textAlign: 'center', textDecoration: 'underline' }}>Recommendation Letter</h2>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ height: '30px' }}>&nbsp;</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%">To Whom it May Concern:</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ height: '10px' }}>&nbsp;</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ height: '10px' }}>&nbsp;</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ textAlign: 'justify' }}>
                                                It is a pleasure to recommend { this.state.data.full_name } who has worked here at { this.state.data.company_name }, as { this.state.data.designation_name } from { this.handleDate_formate( this.state.data.date_of_joining ) } to { this.handleDate_formate( this.state.data.date_of_exit ) }.
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ height: '10px' }}>&nbsp;</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ textAlign: 'justify' }}>
                                                During { (this.state.data.gender === 'male') ? 'his': 'her' } tenure, we found { (this.state.data.gender === 'male') ? 'him': 'her' } to be a proactive and self-starter, who is highly motivated with exceptional learning capabilities, duty bound, a committed team player with strong conceptual knowledge of { this.state.data.designation_name } activities in the areas { (this.state.data.gender === 'male') ? 'he': 'she' } is assigned for. 
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ height: '10px' }}>&nbsp;</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ textAlign: 'justify' }}>
                                                Along with { (this.state.data.gender === 'male') ? 'his': 'her' } undeniable talent, { (this.state.data.gender === 'male') ? 'he': 'she' } has proved to be efficient, punctual and hardworking and has performed all tasks assigned to { (this.state.data.gender === 'male') ? 'him': 'her' } to the best of our satisfaction. 
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ height: '10px' }}>&nbsp;</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ textAlign: 'justify' }}>
                                                I recommend { this.state.data.full_name } as a dedicated, knowledgeable and an all-around great person. We believe { (this.state.data.gender === 'male') ? 'he': 'she' } will add great value to your organization. 
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ height: '10px' }}>&nbsp;</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ textAlign: 'justify' }}>
                                                Digital Venture wish { (this.state.data.gender === 'male') ? 'him': 'her' } all the best in { (this.state.data.gender === 'male') ? 'his': 'her' } future endeavors. 
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ height: '60px' }}>&nbsp;</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%">Sincerely,</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ height: '60px' }}>&nbsp;</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%">
                                                <Input 
                                                    style={{width: '300px', marginRight: '15px' }} 
                                                    value={ this.state.to_hr }
                                                    onChange={ (e)=> this.setState({ to_hr: e.target.value }) } />
                                                <b>{ this.state.to_hr }</b></td>
                                        </tr>
                                        <tr>
                                            <td width="100%">
                                                <Input 
                                                    style={{width: '300px', marginRight: '15px' }} 
                                                    value={ this.state.to_hr_position }
                                                    onChange={ (e)=> this.setState({ to_hr_position: e.target.value }) } />
                                                { this.state.to_hr_position }</td>
                                        </tr>
                                        <tr>
                                            <td width="100%">
                                                <Input 
                                                    style={{width: '300px', marginRight: '15px' }} 
                                                    value={ this.state.to_hr_email }
                                                    onChange={ (e)=> this.setState({ to_hr_email: e.target.value }) } />
                                                { this.state.to_hr_email }</td>
                                        </tr>
                                        <tr>
                                            <td width="100%">
                                                <Input 
                                                    style={{width: '300px', marginRight: '15px' }} 
                                                    value={ this.state.to_hr_company }
                                                    onChange={ (e)=> this.setState({ to_hr_company: e.target.value }) } />
                                                { this.state.to_hr_company }</td>
                                        </tr>
                                    </tbody>
                                </table>

                            </td>
                        </tr>

                    </tbody>

                    <tfoot>
                        <tr>
                            <td width="100%" valign="top" colSpan={0}>

                                <table width="100%" className="fixed_footer">
                                    <tbody>
                                        <tr>
                                            <td valign="top" width="33.33%" style={{ color: '#999' }}>
                                                <span><b>{ this.state.data.company_name }</b></span>
                                                <span>{ this.state.data.website }</span>
                                            </td>
                                            <td valign="top" width="33.33%" style={{ color: '#999' }}>
                                                <span style={{width: '80%'}}>
                                                <i className="footer_icon maps_flags" />    
                                                { this.state.data.company_address }</span>
                                            </td>
                                            <td valign="top" width="33.33%" style={{ color: '#1185db' }}>
                                                <span><i className="footer_icon phone_call" />{ this.state.data.phone1 }</span>
                                                <span><i className="footer_icon email" />{ this.state.data.email }</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                            </td>
                        </tr>
                    </tfoot>

                </table>


            </div>
        )
    }
}

function mapStatetoProps( state ){
    return {
        print: state.print
    }
}

export default connect( mapStatetoProps, { get_letter } )( RecommendationLetter );



// WEBPACK FOOTER //
// ./src/pages/prints/dv-recommendation-letter/index.js